rdefine("app/formular/components/HeadForm",['app/formular/components/BaseFormEl'],function(BaseFormEl){
    return BaseFormEl.extend({
        bindings:{
            'i':{
              mod:{
                  '':'model.icon'
              }

            },
            'span':{
                text:'model.name'
            }
        },
        initialize:function(){
            BaseFormEl.prototype.initialize.apply(this,Array.prototype.slice(arguments,0));
            this.$el.html("<i style='margin-left:-5px;width: 20px;'></i> <span> </span>");
        }
    });
});